import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AddPrizeComponent } from './add-prize/add-prize.component';
import { AllPrizesComponent } from './all-prizes/all-prizes.component';
import { EditPrizeComponent } from './edit-prize/edit-prize.component';


const routes: Routes = [
  {
    path: '',
    component: AllPrizesComponent
  },
  {
    path: 'new',
    component: AddPrizeComponent
  },
  {
    path: ':id',
    component: EditPrizeComponent
  }
  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PrizesRoutingModule { }
